<template lang="pug">
  b-modal(
    size="lg",
    v-model="show",
    header-class="lmm-table-list-modal-header",
    @hide="close"
    hide-footer
  )
    template(slot="modal-header")
      //img.logo(:src="`${AppState.Path.image}/main_logo.png`")
      img(src="../../assets/main_logo.png" style="height: 20px")
      b-button.close-btn(
        variant="danger"
        size="sm",
        @click="close"
      ) X
    b-container(fluid)
      b-row.title
        div 승인 업체 / 담당자
      b-card.mt-4
        div.header-container
          div 업체
          b-form-input(type="text", placeholder="업체 검색", v-model="companyNameInput" @keyup.enter="searchCompanyButton")
          b-button(variant="primary", @click="searchCompanyButton") 검색
        b-table(:items="companyItems", :fields="companyFields" :tbody-tr-class="tbodyTrClass")
          template(v-slot:cell(add)="row")
            template(v-slot(selected)="row")
            b-button(size="sm", @click="rowClickHandler(row.item)")
              icon(name="plus")

      b-card.mt-3
        div.header-container
          div 담당자
          b-form-input(type="text", placeholder="담당자 검색", v-model="managerNameInput" @keyup.enter="searchManagerButton")
          b-button(variant="primary" :disabled="this.result.length === 0" @click="searchManagerButton" ) 검색
        b-table(:items="managerItems", :fields="managerFields" :tbody-tr-class="tbodyTrClass")
          template(v-slot:cell(add)="row")
            b-button(size="sm", @click="rowClickHandler(row.item)")
              icon(name="plus")

      div.mt-3.d-flex.justify-content-center
        b-button(variant="primary", @click="handleSend" ) 선택완료

</template>

<script>
import _ from "lodash";
import {PartnersAPI} from "@/api";

const companyStoreKey = `companies`
const managerStoreKey = `managers`

const defaultValues = {
  size: 'sm',
  title: '',
  context: '',
  headerBgVariant: 'light',
  headerTextVariant: 'dark',
  bodyBgVariant: 'light',
  bodyTextVariant: 'dark',
  footerBgVariant: 'light',
  footerTextVariant: 'dark',
  align: 'center'
}

export default {
  name: 'company-select-dialog',
  methods: {
    close () {
      this.show = false
      this.companyNameInput = null
      this.managerNameInput = null
      this.companyItems = []
      this.managerItems = []
      this.result = []
    },
    searchCompanyButton() {
      this.getDataFromServer(companyStoreKey)
    },
    searchManagerButton() {
      this.getDataFromServer(managerStoreKey)
    },
    // 선택 완료 관련 로직
    handleSend() {
      this.AppState.$emit('send-manager-info', this.result)
      this.close()
    },
    // 플러스 버튼 눌렀을 때 발생하는 로직
    rowClickHandler(eventData) {
      if (Object.keys(eventData)[0] === 'company') {
        this.result = [eventData.company]
        this.resetSelection(this.companyItems);
      } else {
        this.result[1] = eventData
        this.resetSelection(this.managerItems);
      }
      this.managerInfo = eventData

      this.$set(eventData, "isSelected", !eventData.isSelected)
    },
    resetSelection(items) {
      items.forEach(item => {
        item.isSelected = false;
      });
    },
    tbodyTrClass(item) {
      return {
        "table-primary": item.isSelected,
      }
    },
    // server에서 정보를 가져오는 메서드
    getDataFromServer (storeKey) {
      this.$log.info('[LOAD DATA FROM SERVER]')
      const endpoint = `partners_${storeKey}_groups`

      const inputDataMap = {
        'companies': this.companyNameInput,
        'managers': this.managerNameInput,
      };

      let params = {input_data: inputDataMap[storeKey]}

      if (storeKey === 'managers') {
        params = {
          input_data: inputDataMap[storeKey],
          company_name: this.result[0]
        }
      }

      PartnersAPI.get(endpoint, {params})
          .then(resp => {
            if (resp.data.objects === null) {
              this.handleEmptyInput(resp)
              return
            }
            else if (resp.data.objects.length === 0) {
              this.handleNotFound(resp)
              return
            }

            this.saveDataToObject(resp)
          })
          .catch(error => {
                console.error(error)
              })
    },
    handleEmptyInput(data) {
      if (this.isCompaniesURL(data.config.url)) {
        this.$awn.alert('업체명을 입력해주세요.')
      }

      if (this.isManagersURL(data.config.url)) {
        this.$awn.alert('담당자 이름을 입력해주세요.')
      }
    },
    handleNotFound(data) {
      if (this.isCompaniesURL(data.config.url)) {
        this.$awn.alert('검색되는 업체가 없습니다.')
      }

      if (this.isManagersURL(data.config.url)) {
        this.$awn.alert('검색되는 담당자가 없습니다.')
      }
    },
    saveDataToObject(data) {
      if (this.isCompaniesURL(data.config.url)) {
        this.companyItems = data.data.objects
      }

      if (this.isManagersURL(data.config.url)) {
        this.managerItems = data.data.objects
      }
    },
    isCompaniesURL(url) {
      return url.includes('companies');
    },
    isManagersURL(url) {
      return url.includes('managers');
    },
  },
  created() {
    this.dialog = defaultValues
    this.AppState.$on('show-company-select-modal', data => {
      this.dialog = _.assign(this.dialog, data)
      this.show = true
    })
  },
  data() {
    return {
      show: false,
      companyNameInput: null,
      managerNameInput: null,
      isBusy: false,
      dialog: {},
      managerInfo: {},
      companyFields: [
        {key: 'company', label: '회사명'},
        {key: 'add', label: '추가', thClass: 'text-right', tdClass: 'text-right'},
      ],
      companyItems: [],
      managerFields: [
        {key:'name', label: '이름'},
        {key:'part', label: '부서명'},
        {key:'email', label: '이메일'},
        {key:'phone', label: '전화번호'},
        {key:'user_type', label: '권한'},
        {key: 'add', label: '추가', thClass: 'text-right', tdClass: 'text-right'},
      ],
      managerItems: [],
      result: [],
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  justify-content: center;
  margin: 1rem 0 0 0;
  > div {
    font-size: 2rem;
    font-weight: 550;
    letter-spacing: 1px;
  }
}

.header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  * {
    margin: 0.5rem;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    height: 38px;
    border-radius: 0.5rem;
    background: #9C9C9C;
    color: #FFFFFF;
    text-align: center;
    font-size: 1.2rem;
  }

  > .form-control {
    width: 80%;
    border-radius: 0.5rem;
  }

  > .btn {
    width: 10%;
    border-radius: 0.5rem;
  }
}

.card-body {
  padding: 1rem 1rem;
  max-height: 15rem; /* 테이블의 최대 높이 지정 */
  overflow-y: scroll; /* 세로 스크롤을 표시할 때만 스크롤바를 보여줌 */
}

.btn-secondary {
  color: #6F6F6F !important;
  background-color: #FFFFFF;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

</style>
